import angular from 'angular';
import _ from 'lodash';

angular.module('webTools').directive('wtDroppable', ['Dialog', '$timeout', 'ModalWindow', 'Utility', 'DropHandler', '$ngRedux',
    function (Dialog, $timeout, ModalWindow, Utility, DropHandler, $ngRedux) {       
        return {
            link: function (scope, element) {

                const store = $ngRedux.getState();
                
                var el = element[0];
                var enterTarget = null;
                var isIE11 = Utility.checkForIE() === 11;
                element.append('<div id="overlay" class="hidden"><img src="../images/drop-icon-blue.png" /></div>')

                el.addEventListener(
                    'dragover',
                    function (e) {
                        e.dataTransfer.dropEffect = 'copy';

                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    },
                    false
                );

                el.addEventListener(
                    'dragenter',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                            enterTarget = e.target;
                            angular.element('#overlay').addClass('drop-overlay');
                            return false;
                    },
                    false
                );

                el.addEventListener(
                    'dragleave',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        if (enterTarget === e.target) {
                            angular.element('#overlay').removeClass('drop-overlay');
                            return false;
                        }
                    },
                    false
                );

                el.addEventListener(
                    'drop',
                    function (e) {

                        if (e.stopPropagation) e.stopPropagation();
                        e.preventDefault();

                        DropHandler.getFiles(e.dataTransfer).then(function (files) {

                            var openDialog = function (errorMessage) {
                                angular.element('#overlay').removeClass('drop-overlay');
                                if (errorMessage !== '') {
                                    ModalWindow.openNotification(errorMessage);
                                    return false;
                                } else {
                                    Dialog.openImport(files);
                                }
                            };

                            $timeout(function () {
                                scope.checkFileSize(files, openDialog);
                            });

                            return false;
                        });
                    },
                    false
                );

                scope.checkFileSize = function (files, callback) {
                    var errorString = '';

                    /* eslint-disable  no-unused-vars */
                    var foundFolder = false;
                    var isFile = false;
                    /* eslint-enable  no-unused-vars */

                    if (files.length === 0 && isIE11) {
                        callback('Dropping folders is not allowed.'); return;
                    } else if (files.length === 0) {
                        callback('Dropped folder contains no files.'); return;
                    } else if (Utility.checkForIE() !== false) {
                        callback(''); return;
                    }

                    _.each(files, function (file) {
                        if (file.size > store.app.maxFileSize * 1024) { errorString = '<strong>' + file.name + '</strong> exceeds maximum allowed file size.'; return false; }
                    });

                    $timeout(function () { callback(errorString); }, 1);
                };
            }
        };
    }]
);